import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

/**
 * PM5 T1 (chrome, batch "common") — converted from MUI v4 + `makeStyles` to
 * MUI v5+ (`@mui/material`) `sx`. See docs/mui-conversion-guide.md.
 */

type ErrorMessageProps = {
  title: string;
  message: string;
  linkHome: boolean;
};

// was: useStyles().largeTitle
const largeTitleSx = {
  fontSize: "4rem",
  color: "common.white",
};

// was: useStyles().marginSpacing
// `color: "text.primary"` is NOT in the v4 rule — it restores a v4 default
// (guide §2, "Button default color"; same fix as Footer's moreInfoButtonSx).
// This `<Button>` carries no `color` prop, so in v4 it was `color="default"`,
// whose root style was `color: theme.palette.text.primary`. v5+ deleted the
// `default` colour and made `primary` the default, which here would paint the
// label `primary.main` (#99ca3c) on the lime `typography.button` background —
// i.e. invisible. Pinning it keeps the button rendering exactly as it does today.
const marginSpacingSx = {
  margin: "20px 0",
  color: "text.primary",
};

function ErrorMessage(props: ErrorMessageProps) {
  return (
    <Container fixed>
      <Grid container>
        {/* v5+ Grid: the `item` prop is gone and the breakpoint props are
            collapsed into `size`. With the container's spacing at its default
            of 0 the computed width is identical to v4's.

            The v4 element also carried `alignItems="center" alignContent="center"`.
            v4 applied those classes unconditionally (only the propTypes warned
            they need `container`), but this element is a flex *child*, not a
            flex container, so `align-items` / `align-content` on it have never
            had any rendered effect. v5+'s Grid has no such props at all, so
            keeping them would forward two unknown attributes to the DOM. Dropped
            as a dead rule (guide §1.2 row 1), not as a tidy-up. */}
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          {/* v4's bare `Box` system props (`my`, `alignItems`, `textAlign`) are
              removed in v9 — they must be `sx` keys or they apply nothing
              (guide §2, "Box system props"). */}
          <Box sx={{ my: 10, alignItems: "center", textAlign: "center" }}>
            <Typography variant="h1" sx={largeTitleSx}>
              {props.title}
            </Typography>
            <Typography variant="h3" color="primary">
              {props.message}
            </Typography>
            {props.linkHome && (
              <Link to="/" style={{ textDecoration: "none" }}>
                <Button size="small" sx={marginSpacingSx}>
                  Go back to Home
                </Button>
              </Link>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default ErrorMessage;
